import React from 'react';
import Slider from 'react-slick';
import firstSlideLogoEs from 'assets/images/login/first-slide-logo-es.png';
import firstSlideLogoEn from 'assets/images/login/first-slide-logo-en.png';
import firstSlideLogoPt from 'assets/images/login/first-slide-logo-pt.png';
import secondSlideLogoEs from 'assets/images/login/second-slide-logo-es.png';
import secondSlideLogoEn from 'assets/images/login/second-slide-logo-en.png';
import secondSlideLogoPt from 'assets/images/login/second-slide-logo-pt.png';
import thirdSlideLogoEs from 'assets/images/login/third-slide-logo-es.png';
import thirdSlideLogoEn from 'assets/images/login/third-slide-logo-en.png';
import thirdSlideLogoPt from 'assets/images/login/third-slide-logo-pt.png';
import fourthSlideLogo from 'assets/images/login/fourth-slide-logo.png';
import { useTranslation } from 'react-i18next';
import bcx from 'bem-classname';
import cx from 'classnames';
import LoginSlide from './LoginSlide';

const logoSourceMapper: Readonly<Record<number, Readonly<Record<string, string>>>> = {
  0: {
    es: firstSlideLogoEs,
    en: firstSlideLogoEn,
    pt: firstSlideLogoPt,
  },
  1: {
    es: secondSlideLogoEs,
    en: secondSlideLogoEn,
    pt: secondSlideLogoPt,
  },
  2: {
    es: thirdSlideLogoEs,
    en: thirdSlideLogoEn,
    pt: thirdSlideLogoPt,
  },
};

function LoginSlider(): JSX.Element {
  const { t, i18n } = useTranslation('LANDING');
  const { language } = i18n;

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: false,
    arrows: false,
    pauseOnHover: false,
  };

  return (
    <Slider
      {...settings}
      className={cx(
        'login-gradient-bg mb-0 position-fixed  m-4 d-none d-lg-flex flex-column justify-content-center',
        bcx('login', 'slider-wrapper'),
      )}
    >
      <LoginSlide
        imageSrc={logoSourceMapper[0][language]}
        title={t('LANDING:NEW_CAROUSEL_HEADER_1')}
        text={t('LANDING:NEW_CAROUSEL_DESCRIPTION_1')}
        name="first-slide"
      />
      <LoginSlide
        imageSrc={logoSourceMapper[1][language]}
        title={t('LANDING:NEW_CAROUSEL_HEADER_2')}
        text={t('LANDING:NEW_CAROUSEL_DESCRIPTION_2')}
        name="second-slide"
      />
      <LoginSlide
        imageSrc={logoSourceMapper[2][language]}
        title={t('LANDING:NEW_CAROUSEL_HEADER_3')}
        text={t('LANDING:NEW_CAROUSEL_DESCRIPTION_3')}
        name="third-slide"
      />
      <LoginSlide
        imageSrc={fourthSlideLogo}
        title={t('LANDING:NEW_CAROUSEL_HEADER_4')}
        text={t('LANDING:NEW_CAROUSEL_DESCRIPTION_4')}
        name="fourth-slide"
      />
    </Slider>
  );
}

export default LoginSlider;
